import {
  BATCH_NAMING_HELP,
  batchesForCourse,
  suggestNextBatchName,
} from '../../domain/batch/batchNaming';

/**
 * Shows the Batch-1, Batch-2 convention on Add User when a batch will be created.
 */
export default function BatchNamingHint({
  batches = [],
  courseId,
  willCreate = false,
  existingName = '',
}) {
  const nextName = suggestNextBatchName(batchesForCourse(batches, courseId));

  if (existingName && !willCreate) {
    return (
      <p className="text-xs" style={{ color: 'var(--color-text-secondary)' }}>
        {BATCH_NAMING_HELP} This enrollment uses <span className="font-mono">{existingName}</span>.
      </p>
    );
  }

  if (!willCreate && !courseId) {
    return (
      <p className="text-xs" style={{ color: 'var(--color-text-secondary)' }}>
        {BATCH_NAMING_HELP}
      </p>
    );
  }

  return (
    <p className="text-xs" style={{ color: 'var(--color-text-secondary)' }}>
      {BATCH_NAMING_HELP}
      {willCreate && courseId ? (
        <>
          {' '}
          Next name: <span className="font-mono font-semibold">{nextName}</span>.
        </>
      ) : null}
    </p>
  );
}
